<template>
  <modal :visible="modalVisible"
         prevent-backdrop-close
         @modal-close="handleModalClose"
         size="md">
    <div class="tos-header">
      <img src="/assets/images/logo_mobile.svg" alt="" class="logo">
      <img src="/assets/images/saglasnost.svg" alt="" class="consent-image">
      <h2>{{ $t('tosAgreementModal.title') }}</h2>
    </div>
    <div class="tos-body">
      <p class="description">{{ $t('tosAgreementModal.description') }}</p>
      <base-checkbox v-model="tosAgree" variant="green" ref="consentCheckbox">
        <span class="tos-checkbox" v-html="$t('tosAgreementModal.link', { url: agreementLink})"></span>
      </base-checkbox>
      <div class="button-container">
        <base-button variant="primary" :disabled="!tosAgree" @click="giveConsent">{{ $t('common.continue') }}</base-button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/common/modal/modal'
import { customRouter } from '@/customRouter'
import { lsGet, lsSave } from '@/utils/localStorageController'
import errorMessageHandler from '@/mixins/errorMessageHandler'
import logout from '@/mixins/logout'
import { addDataLayerEvent } from '@/services/dataLayer'

export default {
  name: 'terms-of-use-check',
  data () {
    return {
      modalVisible: false,
      tosAgree: false,
      agreementLink: '',
      agreementVersion: null,
      agreementId: '',
      userConfirmedTos: false
    }
  },
  mixins: [errorMessageHandler, logout],
  components: { Modal },
  methods: {
    setModalAsVisible () {
      this.modalVisible = true
      setTimeout(() => {
        this.$refs.consentCheckbox.$el.getElementsByTagName('input')[0].focus()
      }, 200)
    },
    checkTosUpdates () {
      this.$apiRequest.get('user/consenttemplates')
        .then(response => {
          const consentNotAccepted = response.data.consentTemplates.filter(consent => !consent.currentConsent && consent.id === 'GENERAL_TERMS_AGREEMENT')
          if (consentNotAccepted.length) {
            this.checkTosById(consentNotAccepted[consentNotAccepted.length - 1].id)
          } else {
            this.$emit('terms-ok')
            lsSave('sc_tosConfirmed', true)
          }
        })
        .catch(e => {
          // silently fail
          // this.handleErrorMessage(e.response.data)
          this.$emit('terms-ok')
        })
    },
    checkTosById (agreementId) {
      this.$apiRequest.get('user/getconsent?consentTemplateId=' + agreementId)
        .then(response => {
          if (!response.data.currentConsent) {
            this.agreementId = agreementId
            this.agreementLink = response.data.description
            this.agreementVersion = response.data.version
            this.setModalAsVisible()
          } else {
            lsSave('sc_tosConfirmed', true)
            this.$emit('terms-ok')
          }
        })
        .catch(e => {
          // silently fail
          // this.handleErrorMessage(e.response.data)
          this.$emit('terms-ok')
        })
    },
    giveConsent () {
      const consentData = {
        consentTemplateId: this.agreementId,
        consentTemplateVersion: this.agreementVersion
      }
      if (this.tosAgree) {
        this.$apiRequest.post('user/giveconsent', consentData)
          .then(response => {
            if (response.status >= 200 && response.status < 400) {
              this.userConfirmedTos = true
              lsSave('sc_tosConfirmed', true)
            }
          })
          .catch(e => {
            this.handleErrorMessage(e.response.data)
          })
          .finally(() => {
            this.modalVisible = false
            this.$emit('terms-ok')
          })
      }
    },
    handleModalClose () {
      if (!this.userConfirmedTos) {
        addDataLayerEvent({
          reason: 'consent',
          event: 'login_failed'
        })
        setTimeout(() => {
          this.logoutUser()
        }, 10)
      }
    }
  },
  mounted () {
    // TODO Refactor to get private route from ID set from BE
    // TODO Refactor to exclude the whole modal from the DOM, if it's not needed
    if (!customRouter.isPublicRoute() && !lsGet('sc_tosConfirmed')) {
      this.checkTosUpdates()
    } else {
      this.$emit('terms-ok')
    }
  }
}
</script>

<style scoped lang="scss">
.tos-header {
  text-align: center;

  img.logo {
    width: 165px;
    height: auto;
    display: inline-block;
    margin: 0;
  }

  img.consent-image {
    width: 100%;
    max-width: 280px;
    height: auto;
    display: block;
    margin: 3.2rem auto 0;
  }

  h2 {
    font-size: 3.2rem;
    color: $text;
    margin-top: 2.4rem;
    margin-bottom: 1.6rem;
    font-weight: normal;
  }
}

.tos-body {
  text-align: center;

  .description {
    margin-bottom: 4rem;
  }

  .tos-checkbox {
    font-size: 16px;
  }

  .button-container {
    text-align: center;
    margin-top: 4rem;
  }
}
</style>
